import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MaintenanceWrapper from './components/MaintenanceWrapper';
import Navbar from './components/layout/Navbar';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import MyCEUs from './pages/MyCEUs';
import ViewCEU from './pages/ViewCEU';
import AddCEU from './pages/AddCEU';
import EditCEU from './pages/EditCEU';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import SignIn from './pages/SignIn';
import OAuthCallback from './pages/OAuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import ComponentDemo from './pages/ComponentDemo';
import TestCycleRenewal from './pages/TestCycleRenewal';

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  return (
    <MaintenanceWrapper>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/demo" element={<ComponentDemo />} />
          <Route path="/test-cycle-renewal" element={<TestCycleRenewal />} />
          <Route path="/admin-override" element={<div>Switching to admin mode...</div>} />

          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div>
                  <Navbar />
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/my-ceus" element={<MyCEUs />} />
                    <Route path="/view-ceu/:ceuId" element={<ViewCEU />} />
                    <Route path="/add-ceu" element={<AddCEU />} />
                    <Route path="/edit-ceu/:ceuId" element={<EditCEU />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                  </Routes>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </MaintenanceWrapper>
  );
}

export default App;
